var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.id,class:{ active: _vm.selectedTab === tab.id },on:{"click":function($event){return _vm.selectTab(tab.id)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }